import urlFromRouteObj from 'root/src/client/logic/route/util/urlFromRouteObj'

export default (state, { routeId, routeParams, href, query, hash }) => {
	if (routeId) {
		return urlFromRouteObj({ routeId, routeParams, query, hash })
	}
	return href
}
